"use strict";

var _interopRequireDefault = require("/app/node_modules/@babel/runtime/helpers/interopRequireDefault").default;

require("/app/node_modules/core-js/modules/es.array.iterator.js");

require("/app/node_modules/core-js/modules/es.promise.js");

require("/app/node_modules/core-js/modules/es.object.assign.js");

require("/app/node_modules/core-js/modules/es.promise.finally.js");

var _vue = require("vue");

var _App = _interopRequireDefault(require("./App.vue"));

var _router = _interopRequireDefault(require("./router"));

var _quasar = require("quasar");

var _quasarUserOptions = _interopRequireDefault(require("./quasar-user-options"));

var _axios = _interopRequireDefault(require("axios"));

var _vueAxios = _interopRequireDefault(require("vue-axios"));

_axios.default.defaults.headers.common['Content-Type'] = 'application/x-www-form-urlencoded';
_axios.default.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
(0, _vue.createApp)(_App.default).use(_quasar.Quasar, _quasarUserOptions.default).use(_vueAxios.default, _axios.default).use(_router.default).mount('#app');